<template>
	<div class="wspro-resources-detail">
		<div class="breadcrumbs" id="breadcrumbs">
			<router-link class="breadcrumb-link" to="/resources">Resources</router-link>  &gt;
			<a class="breadcrumb-link active" :href="'/resources/' + item.post_name">{{ item.post_title }}</a>
		</div>
		<h3>{{ item.post_title }} <span>Resource</span></h3>
		<div id="resources-detail-wrapper">
			<div id="resources-detail-nav" role="navigation">
				<b-navbar class="flex-column" v-b-scrollspy:resources-detail-content="95">
					<b-nav pills vertical>
						<div v-for="navItem in nav" :key="navItem.href">
							<b-nav-item :to="navItem.href">
								{{ navItem.text }}
							</b-nav-item>
							<b-nav pills vertical v-if="navItem.children.length">
								<b-nav-item v-for="subItem in navItem.children" :key="subItem.href" :to="subItem.href">
									{{ subItem.text }}
								</b-nav-item>
							</b-nav>
						</div>
					</b-nav>
				</b-navbar>
			</div>
			<div id="resources-detail-content" v-html="resContent" ref="resContent"></div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'ResourcesDetail',
	data() {
		return {
			pageParams: {
				pageOptions: { page:1, sortBy:[], sortDesc:[], itemsPerPage: 10 },
				search: { val: "" },
				filters: { }
			},
			navMenuLoaded: false,
			resourceLoaded: false,
			nav: [],
			resContent: null
		}
	},
	methods: {
		getPage(params) {
			this.getPageHandler({
				waitName: 'resources.detail',
				action: 'fetchResource', // vuex action
				pageParams: this.pageParams,
				isInit: params ? params.init : false, // parse from url query params
				pushRoute: true, // push pagination params and search q to route
				resetPagination: params ? params.resetPagination : false, // new search input -> need to reset page & sorting
				routeParams: { resSlug: this.$route.params.slug }
			});
		},
		async fetchData() {
			this.dispatchWaitAndNotify('fetchResource', { resSlug: this.$route.params.slug }, false, true);
			this.resourceLoaded = true;
		},
		renderNavMenu() {
			if (!this.navMenuLoaded && this.resourceLoaded) {
				let parser = new DOMParser();
				let doc = parser.parseFromString(this.item.post_content, 'text/html')
				let navNodeList = doc.querySelectorAll('h2, h3');
				for (let i = 0, j = 0, k = 0; i < navNodeList.length; i++) {
					if (navNodeList[i].nodeName === 'H2') {
						navNodeList[i].setAttribute('id', 'item-' + (j + 1));
						k = 0;
						this.nav[j] = {
							'href':	'#item-' + (j + 1),
							'text':	navNodeList[i].innerText,
							'children': []
						};
						j++;
					} else if (navNodeList[i].nodeName === 'H3') {
						navNodeList[i].setAttribute('id', 'item-' + j + '-' + (k + 1));
						this.nav[j - 1]['children'][k] = {
							'href':	'#item-' + j + '-' + (k + 1),
							'text':	navNodeList[i].innerText
						};
						k++;
					}
				}
				this.navMenuLoaded = true
				this.resContent = doc.querySelector('body').innerHTML;
			}
		}
	},
	mounted() {
		//this.getPage({ init:true });
		if (!this.resourceLoaded) this.fetchData();
	},
	updated() {
		this.$nextTick(() => {
			if(this.$route.hash) {
				const el = document.querySelector(this.$route.hash);
				el && el.scrollIntoView();
			}
		})
	},
	computed: {
		item() {
			return this.$store.state.resources.detail;
		}
	},
	watch: {
		item(data) {
			if (data.post_content) {
				this.renderNavMenu();
			}
		}
	}
}
</script>

<style>

</style>
